import React, { useEffect,useState,useRef } from "react";
import { Hooks,Util,Request,Config, Context } from "@xt/xtbase";
const {useTranslation} = Hooks;
const {moment,Big,getUrl,showRate} = Util;
const {XtSocketPublic} = Request;
const { XtContext } = Context;
import styles from "./index.module.less";
import {get_kline,get_ticker24h,get_topConfig,get_cfdMarketTopConfig} from "@/api/v4/market";
import { useStore } from '@/models';
import { observer } from 'mobx-react-lite';
import XtPane from "@/components/App/XtPane";
import LineChart from "@/components/App/LineChart";
import moreImg from "assets/images/home/moreImg.png";
import HomeNotice from "@/components/Pages/Home/HomeNotice";
import HomeScrollCard from "@/components/Pages/Home/HomeScrollCard";
import LandingAiStrategyList from "@/components/Pages/Home/HomeMarket/LandingAiStrategyList";
import AiSelectNavButton from "@/components/App/AiSelectNavButton";
import { isAiselectEligibleSymbol } from "@/utils/aiSelectEligible";

const cacheData = {};
const marketsChartMap = {};
const kInterval = "1h";
const kLimit = 24;
let klineEvents = [];
let barList = [];
const HomeMarket = (props) => {
  const { landingMarketBar } = props;
  const t = useTranslation();
  const { fund, market } = useStore();
  const [appState] = React.useContext(XtContext);
  const [chooseTab, setChooseTab] = useState("hot");
  const [chooseSubTab, setChooseSubTab] = useState("Spot");
  const [loading, setLoading] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [chartList, setChartList] = useState([]);
  const [cfdTopConfig, setCfdTopConfig] = useState(null);
  const chooseTabRef = useRef(chooseTab);
  const chooseSubTabRef = useRef(chooseSubTab);
  useEffect(()=>{
    initMakertGroup();
    XtSocketPublic.addChannel({event:"tickers"}, handleWsCallback);
    return ()=>{
      XtSocketPublic.removeChannel({ event: "tickers" });
      if (klineEvents && klineEvents.length > 0) {
        klineEvents.forEach((s) => {
          XtSocketPublic.removeChannel({ event: "kline@" + s + "," + kInterval });
        });
      }
    }
  },[appState?.userInfo?.authLevel, appState?.userInfo?.fiatCurrencyIds, appState?.loginStatus]);
  useEffect(()=>{
    initChartData();
  },[groupList]);
  const handleWsCallback = (res) => {
    if (!Array.isArray(res) || res.length <= 0 || !Array.isArray(cacheData.allMarketData)) return;
    var list = [...barList];
    res.forEach((r) => {
      let i = cacheData.allMarketData.findIndex((d) => {
        return d.s == r.s;
      });
      if (i >= 0) cacheData.allMarketData[i] = r;
      let j = list.findIndex((d) => {
        return d.s == r.s;
      });
      if(j >= 0)
      {
        list[j] = r;
      }
    });
    barList = list;
    handleGroupList(chooseTabRef.current, chooseSubTabRef.current);
  }
  const handleWsKlineCallback = (res)=>{
    if (!marketsChartMap[res.s]) marketsChartMap[res.s] = [];
    var list = [];
    var flag = true;
    marketsChartMap[res.s].forEach((item) => {
      if (item.t == res.t) {
        list.push(res);
        flag = false;
      } else list.push(item);
    });
    if (flag) list.unshift(res);
    marketsChartMap[res.s] = list;
    //setChartList((groupList.map((g) => {
    //  return marketsChartMap[g.s] || [];
    //})));
  }
  const changeGroupList = (newList) => {
    let addList = [];
    let removeList = [];
    if (Array.isArray(newList) && newList.length > 0) {
      newList.forEach((item) => {
        addList.push(item.s);
      });
    }
    if (Array.isArray(klineEvents) && klineEvents.length > 0) {
      klineEvents.forEach((item) => {
        let i = addList.indexOf(item);
        if (i >= 0) addList.splice(i, 1);
        else removeList.push(item);
      });
    }
    klineEvents = newList.map((item)=>{return item.s});
    if (removeList.length > 0) {
      removeList.forEach((s) => {
        XtSocketPublic.removeChannel({ event: "kline@" + s + "," + kInterval });
      });
    }
    if (addList.length > 0) {
      addList.forEach((s) => {
        XtSocketPublic.addChannel({ event: "kline@" + s + "," + kInterval }, handleWsKlineCallback);
      });
    }
    setGroupList(newList);
    // 顶部轮播与当前下方展示列表保持一致
    barList = newList;
    setChartList((newList.map((g) => {
      return marketsChartMap[g.s] || [];
    })));
  }
  const initMakertGroup = async ()=>{
    try {
      setLoading(true);
      cacheData.allMarketData = await get_ticker24h();
      try {
        const userInfo = appState?.userInfo;
        const hasAuthLevel = userInfo && userInfo.authLevel != null;
        const hasFiatIds = userInfo?.fiatCurrencyIds && Array.isArray(userInfo.fiatCurrencyIds) && userInfo.fiatCurrencyIds.length > 0;
        const body =
          hasAuthLevel || hasFiatIds
            ? {
                ...(hasAuthLevel && { authLevel: userInfo.authLevel }),
                ...(hasFiatIds && { fiatCurrencyIds: userInfo.fiatCurrencyIds.map((id) => String(id)) }),
              }
            : {};
        const res = await get_cfdMarketTopConfig(body, { isAutoPopError: false });
        const data = res?.result ?? res?.data ?? res;
        if (data) {
          cacheData.cfdTopConfig = data;
          setCfdTopConfig(data);
        }
      } catch (err) {
        const fallback = await get_topConfig().catch(() => null);
        const data = fallback?.result ?? fallback?.data ?? fallback;
        if (data) {
          const emptyTabConfig = {
            limit: 10,
            topSymbols: [],
            excludeQuoteCurrencies: [],
            excludeBaseCurrencies: [],
            excludeSymbols: [],
            excludeVolumeLt: null,
          };
          const usdtM = { ...data, tradfi: data.tradfi || emptyTabConfig };
          cacheData.cfdTopConfig = { showFiatM: false, fiatM: null, usdtM, tradfiBaseCurrencies: ["xau", "xag", "wti", "brent", "oil"] };
          setCfdTopConfig(cacheData.cfdTopConfig);
        }
      }
      handleGroupList(chooseTab);
    } catch (error) {
      console.log("initMarket-----", error);
    } finally {
      setLoading(false);
    }
  }
  const handleGroupList = (tab, subTab)=>{
    if(!tab)tab = chooseTab;
    if(!subTab)subTab = chooseSubTab;
    const { allMarketData } = cacheData;
    if (!allMarketData) return;
    const {marketConfig} = market;
    // CFD tab：与首页 Hot Coins 一致，按 cfdTopConfig.usdtM.hot 选币
    if (tab === "hot") {
      const cfdConfig = cacheData.cfdTopConfig || cfdTopConfig;
      const hotCfg = cfdConfig?.usdtM?.hot;
      if (!hotCfg) return;
      const limit = Math.max(0, hotCfg.limit ?? 10);
      let topList = [];
      if (hotCfg.topSymbols && hotCfg.topSymbols.length > 0) {
        for (const symbol of hotCfg.topSymbols) {
          const idx = allMarketData.findIndex((d) => d.s === symbol);
          if (idx >= 0) {
            const row = allMarketData[idx];
            const mConfig = marketConfig?.[row.s];
            const symbolType = (mConfig?.type || "").toUpperCase();
            const quote = (row.s.split("_")[1] || "").toUpperCase();
            if (symbolType === "CFD" && quote === "USDT") {
              topList.push(row);
              if (topList.length >= limit) break;
            }
          }
        }
      }
      let filterlist = allMarketData.filter((d) => {
        if (!d.s) return false;
        const mConfig = marketConfig?.[d.s];
        if (!mConfig || mConfig.state == "DELISTED" || mConfig.displayLevel == "NONE") return false;
        if ((mConfig.type || "").toUpperCase() !== "CFD") return false;
        const parts = d.s.split("_");
        const base = (parts[0] || "").toLowerCase();
        const quote = (parts[1] || "").toLowerCase();
        if (quote !== "usdt") return false;
        if (topList.findIndex((t) => t.s === d.s) >= 0) return false;
        if (hotCfg.excludeSymbols?.includes(d.s)) return false;
        if (hotCfg.excludeBaseCurrencies?.some((c) => (c || "").toLowerCase() === base)) return false;
        if (hotCfg.excludeQuoteCurrencies?.some((c) => (c || "").toLowerCase() === quote)) return false;
        if (hotCfg.excludeVolumeLt != null && hotCfg.excludeVolumeLt !== "") {
          const v = parseFloat(d.v);
          const threshold = parseFloat(hotCfg.excludeVolumeLt);
          if (!Number.isNaN(threshold) && (Number.isNaN(v) || v < threshold)) return false;
        }
        return true;
      });
      const sortByVolume = (x, y) => {
        let xv = parseFloat(x.v) || 0;
        let yv = parseFloat(y.v) || 0;
        const xq = (x.s.split("_")[1] || "").toLowerCase();
        const yq = (y.s.split("_")[1] || "").toLowerCase();
        if (xq !== "usdt") {
          const xu = allMarketData.find((d) => d.s.toLowerCase() === xq + "_usdt");
          if (xu && xu.c) xv *= parseFloat(xu.c) || 0;
        }
        if (yq !== "usdt") {
          const yu = allMarketData.find((d) => d.s.toLowerCase() === yq + "_usdt");
          if (yu && yu.c) yv *= parseFloat(yu.c) || 0;
        }
        return yv - xv;
      };
      filterlist.sort(sortByVolume);
      const take = Math.max(0, limit - topList.length);
      changeGroupList(topList.concat(filterlist.slice(0, take)));
      return;
    }
    const { topConfig } = cacheData;
    if (!topConfig) return;
    const config = topConfig[tab];
    if (!config) return;
    let topList = [];
    if (config.topSymbols) {
      for (let i = 0; i < config.topSymbols.length; ++i) {
        let symbol = config.topSymbols[i];
        let index = allMarketData.findIndex((d) => {
          return d.s == symbol;
        });
        if (index >= 0) {
          topList.push(allMarketData[index]);
          if (topList.length >= 5) break;
        }
      }
    }
    if (topList.length >= 5) {
      changeGroupList(topList.slice(0, 5));
      return;
    }
    let filterlist = allMarketData.filter((d) => {
      if (!d.s) return false;
      const mConfig = marketConfig[d.s];
      if (!mConfig || mConfig.state == "DELISTED" || mConfig.displayLevel == "NONE") return false;
      if (
        topList.length > 0 &&
        topList.findIndex((t) => {
          return t.s == d.s;
        }) >= 0
      )
        return false;
      let coins = d.s.split("_");
      if (coins.length < 2) return false;
      if (config.excludeSymbols && config.excludeSymbols.includes(d.s)) return false;
      if (config.excludeBaseCurrencies && config.excludeBaseCurrencies.includes(coins[0])) return false;
      if (config.excludeQuoteCurrencies && config.excludeQuoteCurrencies.includes(coins[1])) return false;
      if (config.excludeVolumeLt) {
        if (coins[1].toLowerCase() == "usdt") {
          if (config.excludeVolumeLt > parseFloat(d.v)) return false;
        } else {
          const c_u = allMarketData.find((d) => {
            return d.s.toLowerCase() == coins[1].toLowerCase() + "_usdt";
          });
          if (!c_u || config.excludeVolumeLt > c_u.c * d.v) return false;
        }
      }
      if (tab == "up" || tab == "down") {
        if (subTab == "Spot" && market.isEtfMarket(d.s)) return false;
        if (subTab == "Etf" && !market.isEtfMarket(d.s)) return false;
      }
      return true;
    });
    if (tab === "up")
      filterlist.sort((x, y) => {
        return (y.cr || y.r) - (x.cr || x.r);
      });
    else if (tab === "down")
      filterlist.sort((x, y) => {
        return (x.cr || x.r) - (y.cr || y.r);
      });
    else if (tab === "hot"){
      filterlist.sort((x, y) => {
        let xv = x.v;
        let yv = y.v;
        const xcoins = x.s.split("_");
        if (xv > 0 && xcoins.length > 1 && xcoins[1].toLowerCase() != "usdt") {
          const xs_u = allMarketData.find((d) => {
            return d.s.toLowerCase() == xcoins[1].toLowerCase() + "_usdt";
          });
          if (xs_u) xv *= xs_u.c;
        }
        const ycoins = y.s.split("_");
        if (yv > 0 && ycoins.length > 1 && ycoins[1].toLowerCase() != "usdt") {
          const ys_u = allMarketData.find((d) => {
            return d.s.toLowerCase() == ycoins[1].toLowerCase() + "_usdt";
          });
          if (ys_u) yv *= ys_u.c;
        }
        return yv - xv;
      });
    }
    else if (tab === "newest")
      filterlist.sort((x, y) => {
        return getMaketOpenTimeTs(y.s) - getMaketOpenTimeTs(x.s);
      });
    changeGroupList(topList.concat(filterlist.slice(0, 5 - topList.length)));
  }
  const initChartData = ()=>{
    if (!groupList?.length) return;
    groupList.forEach((item) => {
      if (marketsChartMap[item.s] && marketsChartMap[item.s].length > 0) return;
      get_kline({
        params: {
          symbol: item.s,
          interval: kInterval,
          limit: kLimit,
        },
      }).then((data) => {
        marketsChartMap[item.s] = data;
        setChartList((groupList.map((g) => {
          return marketsChartMap[g.s] || [];
        })));
      });
    });
  }
  const handleChangeTab = (tab)=>{
    setChooseTab(tab);
    chooseTabRef.current = tab;
    setChooseSubTab("Spot");
    chooseSubTabRef.current = "Spot";
    handleGroupList(tab,"Spot");
  }
  const onMarketGroupClick = (item)=>{
    location.href = getUrl(`/futures/detail/${item.s}`);
  }
  const getCoinIcon = (symbol) => {
    if (!symbol) return require("@/assets/images/common/icon404.png").default;
    const { currencyMap } = fund;
    const coin = symbol.split("_")[0];
    const rawLogo = currencyMap && currencyMap[coin] && currencyMap[coin]["logo"];
    if (!rawLogo) return require("@/assets/images/common/icon404.png").default;
    // 仅用于展示时替换域名，不修改 MobX observable，避免 strict-mode 报错
    const domain = typeof document !== "undefined" ? document.domain : "";
    const domain2 = domain.substring(domain.indexOf(".") + 1);
    if (!domain.startsWith("xt") && rawLogo) {
      return rawLogo.replace("xt.com", domain2) || rawLogo;
    }
    return rawLogo;
  }
  const getCoinName = (symbol) => {
    if (!symbol) return;
    return symbol.split("_")[0];
  }
  const getMarketName = (symbol) => {
    if (!symbol) return;
    return symbol.split("_").length > 1 ? symbol.split("_")[1] : "";
  }
  const activeAssist = fund.assist || Config.assistConfig.find((item) => item.key === "usd") || { key: "usd", name: "USD", note: "$" };
  const activeAssistKey = (activeAssist.key || "usd").toLowerCase();
  const activeAssistNote = activeAssist.note || "$";
  const convertByAssist = (amount, quoteCurrency) => {
    if (amount == null || Number.isNaN(+amount)) return "0";
    const quote = (quoteCurrency || "").toLowerCase();
    if (!quote) return String(amount);
    if (quote === activeAssistKey) return String(amount);
    const converted = fund.getCoinValue(amount, quote, activeAssistKey);
    if (converted != null && converted !== "" && !Number.isNaN(+converted)) return converted;
    return String(amount);
  };
  const formatPrice = (item) => {
    const { s: marketName, c: latestPrice } = item;
    if (latestPrice == null || isNaN(+latestPrice)) return 0;
    const mConfig = market.marketConfig[marketName];
    const quoteCurrency = getMarketName(marketName);
    const converted = convertByAssist(latestPrice, quoteCurrency);
    return Big(converted).toFixedCy(mConfig && mConfig.buyPoint ? mConfig.buyPoint : 2);
  }
  const fontClass = (rate) => {
    return !isNaN(+rate) && +rate != 0 ? (+rate > 0 ? styles["up-color"] : styles["down-color"]) : styles["up-color"];
  }
  const fontClassGlobal = (rate) => {
    return !isNaN(+rate) && +rate != 0 ? (+rate > 0 ? "up-color" : "down-color") : "down-color";
  }
  const formatRate = (rate) => {
    return showRate(rate * 100);
  }
  const getMaketOpenTime = (symbol) => {
    return market.marketConfig[symbol] ? moment(market.marketConfig[symbol].stateTime).format("YYYY-MM-DD") : "";
  }
  const getMaketOpenTimeTs = (symbol) => {
    return +market.marketConfig[symbol].stateTime;
  }
  const onMarketChange = (key) => {
    setChooseSubTab(key);
    chooseSubTabRef.current = key;
    handleGroupList(chooseTab, key);
  }
  return <>
    <div
      className={`${styles.marketBar} ${landingMarketBar ? styles.marketBarLanding : ""} ${
        landingMarketBar ? "market-bar-landing" : ""
      }`}
    >
      <div className={styles.marketBarScroll}>
        {barList.map((item,index)=>{
          return <a key={"marketBarScroll1_"+index} className={styles.marketBarItem} href={getUrl(`/futures/detail/${item.s}`)}>{item.s.split("_")[0].toUpperCase()} {activeAssistNote}{formatPrice(item)} ({formatRate(item.cr || item.r)})</a>
        })}
      </div>
      <div className={styles.marketBarScroll}>
        {barList.map((item,index)=>{
          return <a key={"marketBarScroll2_"+index} className={styles.marketBarItem} href={getUrl(`/futures/detail/${item.s}`)}>{item.s.split("_")[0].toUpperCase()} {activeAssistNote}{formatPrice(item)} ({formatRate(item.cr || item.r)})</a>
        })}
      </div>
      <div className={styles.marketBarScroll}>
        {barList.map((item,index)=>{
          return <a key={"marketBarScroll3_"+index} className={styles.marketBarItem} href={getUrl(`/futures/detail/${item.s}`)}>{item.s.split("_")[0].toUpperCase()} {activeAssistNote}{formatPrice(item)} ({formatRate(item.cr || item.r)})</a>
        })}
      </div>
    </div>
    {landingMarketBar ? null : <HomeNotice />}
    {landingMarketBar ? null : <HomeScrollCard />}
    <div className={`market-group-container ${styles["market-group-container"]}`}>
      <h2 className={styles["tit"]}>{ t("home.Markets") }</h2>
      <div className={styles["tabs-content"]}>
        <div
          role="tab"
          onClick={() => handleChangeTab("hot")}
          className={chooseTab === "hot" ? styles["tab-active"] : ""}
        >
          {t("home.MarketTabCFD")}
        </div>
        <div
          role="tab"
          onClick={() => handleChangeTab("newest")}
          className={chooseTab === "newest" ? styles["tab-active"] : ""}
        >
          {t("home.MarketTabAITrading")}
        </div>
      </div>
      <div
        className={`market-group-container-view ${styles["market-list-view"]} ${
          landingMarketBar && chooseTab === "newest" ? styles.listViewLandingAi : ""
        }`}
      >
        {landingMarketBar && chooseTab === "newest" ? null : (
          <ul className={styles["list-header"]}>
            <li>{t("home.Name")}</li>
            <li>{t("home.LastPrice")}</li>
            <li>{t("home.24hChange")}</li>
            {chooseTab === "newest" ? <li>{t("home.launchTime")}</li> : null}
            <li>{t("home.Markets")}</li>
          </ul>
        )}
        {landingMarketBar && chooseTab === "newest" ? (
          <div className={`${styles["list-content"]} ${styles.listContentLandingAi}`}>
            <LandingAiStrategyList />
          </div>
        ) : (
          <XtPane className={styles["list-content"]} loading={loading} nodata={false}>
            {groupList.map((item, index) => {
              return (
                <ul key={item.s} className={styles["list-content-ul"]} onClick={() => onMarketGroupClick(item)}>
                  <li>
                    <img src={getCoinIcon(item.s)} alt="" />
                    <span className={styles["text-uppercase"]} style={{ fontSize: "16px" }}>
                      {getCoinName(item.s)}
                    </span>
                    <span style={{ marginTop: "2px" }}>/</span>
                    <span style={{ marginTop: "2px" }} className={styles["text-uppercase"]}>
                      {getMarketName(item.s)}
                    </span>
                    {isAiselectEligibleSymbol(item.s, market.marketConfig) ? (
                      <div className={styles.aiSelectWrap} onClick={(e) => e.stopPropagation()}>
                        <AiSelectNavButton symbol={item.s} className={styles.aiSelectEntry} aria-label={t("header.aicopy")} />
                      </div>
                    ) : null}
                  </li>
                  <li className={styles["last-price-li"]}>
                    <div className={styles["last-price-li-div"]}>
                      <div className={styles["last-price"]}>
                        <span>{activeAssistNote}{formatPrice(item)} </span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <span className={fontClass(item.cr || item.r)}>{formatRate(item.cr || item.r)}</span>
                  </li>
                  {chooseTab === "newest" ? <li>{getMaketOpenTime(item.s)}</li> : null}
                  <li>
                    <LineChart
                      itemKey={"home_market_chart_" + item.s}
                      chartData={chartList[index]}
                      theme={fontClassGlobal(item.cr || item.r)}
                      width={120}
                      height={40}
                    />
                  </li>
                </ul>
              );
            })}
          </XtPane>
        )}
        {landingMarketBar && chooseTab === "newest" ? (
          <div className={`${styles["viewmore-wrapper"]} ${styles.viewmoreWrapperLandingAi}`}>
            <a href={getUrl("/aicopy")} className={`${styles["viewmore"]} ${styles.viewmoreLandingAi}`}>
              <span className={styles.viewmoreLandingAiText}>{t("home.Viewmore")}</span>
              <img src={moreImg} className={styles["more-img"]} alt="" />
            </a>
          </div>
        ) : groupList && groupList.length ? (
          <div
            className={`${styles["viewmore-wrapper"]} ${
              landingMarketBar ? styles.viewmoreWrapperLandingAi : ""
            }`}
          >
            <a
              href={getUrl("/market")}
              className={`${styles["viewmore"]} ${landingMarketBar ? styles.viewmoreLandingAi : ""}`}
            >
              <span
                className={landingMarketBar ? styles.viewmoreLandingAiText : ""}
                style={landingMarketBar ? undefined : { flex: "none" }}
              >
                {t("home.Viewmore")}
              </span>
              <img src={moreImg} className={styles["more-img"]} alt="" />
            </a>
          </div>
        ) : null}
      </div>
    </div>
  </>;
}
export default observer(HomeMarket);